import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

import { RiskQuestionsSurveyOption } from '../../models';

@Component({
  selector: 'app-inyova-grow-multi-box',
  templateUrl: './inyova-grow-multi-box.component.html',
  styleUrls: ['./inyova-grow-multi-box.component.scss'],
  standalone: false
})
export class InyovaGrowMultiBoxComponent {
  @Input() options: RiskQuestionsSurveyOption[];
  @Input() parent: FormGroup;

  get answersFormArray(): FormArray {
    return this.parent.get('selectedAnswerIds') as FormArray;
  }

  get answerValues(): string[] {
    return this.answersFormArray.controls.map((item) => item.value);
  }

  constructor(private fb: FormBuilder) {}

  isChecked(id: number | string) {
    return this.answerValues.includes(id as string);
  }

  onToggleOption(answerId: number | string) {
    if (this.isChecked(answerId)) {
      const index = this.answerValues.indexOf(answerId as string);
      this.answersFormArray.removeAt(index);
      return;
    }

    this.answersFormArray.push(this.fb.control(answerId));
  }
}
